import { useEffect, useState } from 'react';
import Dialog from 'Components/Molecules/Dialog/Dialog';
import Button from 'Components/Atoms/Button/Button';
import { deleteUserMe } from 'Services/user';
import TextField from 'Components/Molecules/TextField/TextField';
import { useUser } from 'Components/Organisms/UserProvider/useUser';
import { useErrors } from 'Components/Organisms/ErrorsProvider';
import { useTranslation, Trans } from 'react-i18next';
import PropTypes from 'prop-types';
import deleteImage from 'assets/icon-delete.svg';

export default function DeleteAccountDialog(props) {
    const { open, onClose } = props;

    const { logout } = useUser();
    const { showUnknownError } = useErrors();
    const [reason, setReason] = useState('');
    const [isConfirmationPage, setIsConfirmationPage] = useState(false);
    const [processing, setProcessing] = useState(false);
    const { t } = useTranslation('profile');

    useEffect(() => {
        if (open) {
            setIsConfirmationPage(false);
            setReason('');
        }
    }, [open]);

    const deleteUser = async () => {
        if (reason.length < 10) {
            return;
        }

        setProcessing(true);
        try {
            await deleteUserMe(reason);
            logout();
        } catch (error) {
            showUnknownError(error);
        } finally {
            setProcessing(false);
            onClose();
        }
    };

    return (
        <Dialog open={open} onClose={onClose} size="sm">
            <div className="text-center">
                {isConfirmationPage ? (
                    <div>
                        <h4 className="mt-6">{t('account.delete.reason.title')}</h4>
                        <div className="text-gray-500 mt-6">
                            <div>{t('account.delete.reason.description')}</div>
                            <TextField
                                value={reason}
                                multiline={true}
                                className="mt-6"
                                placeholder={t('account.delete.reason.label')}
                                onChange={(ev) => setReason(ev.target.value)}
                            />
                        </div>
                        <Button
                            variant="primary"
                            isBusy={processing}
                            className="mt-6"
                            onClick={deleteUser}
                            disabled={reason.length < 10}
                        >
                            {t('account.delete.reason.button')}
                        </Button>
                    </div>
                ) : (
                    <div>
                        <div className="mb-4 flex justify-center">
                            <img src={deleteImage} alt="" />
                        </div>
                        <h4>{t('account.delete.modal.title')}</h4>
                        <div className="text-left text-gray-500 mt-6">
                            <div>
                                <Trans t={t} i18nKey={'account.delete.modal.description'} />
                            </div>
                            <ul className="mt-2">
                                <li className="pb-2">{t('account.delete.modal.list-item-1')}</li>
                                <li className="font-bold py-2">{t('account.delete.modal.list-item-2')}</li>
                                <li className="py-2">{t('account.delete.modal.list-item-3')}</li>
                                <li className="pt-2">{t('account.delete.modal.list-item-4')}</li>
                            </ul>
                        </div>
                        <Button
                            variant="primary"
                            isBusy={processing}
                            className="mt-6"
                            onClick={() => setIsConfirmationPage(true)}
                        >
                            {t('account.delete.modal.button')}
                        </Button>
                    </div>
                )}
            </div>
        </Dialog>
    );
}

DeleteAccountDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};
